import "../App.css";

export default function Paragraph2() {
  return (
    <>
      <div className="paragraph2">
        <h4>What we do ?</h4>
        <div
          style={{
            height: "2px",
            width: "68%",
            backgroundColor: "#F97300",
            margin: "10px 0",
          }}
        ></div>
        <h4>
          भजन मंडली दवारा हर मंगलवार या शनिवार को भजन का कार्यक्रम होता है,
          जिसकी महिलाएं शामिल होती हैं | संस्थान में सभी हिंदू त्योहारों को
          धूमधाम से मनाया जाता है | यहां महिला सशक्तिकरण, योग तथा अन्य
          कल्याणकारी कार्य भी करवाये जाते हैं |
        </h4>
      </div>
    </>
  );
}
